import {getMethod, postMethod, putMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/api/locationPoints', request, cancelToken)
}

async function post(request) {
    return await postMethod('/api/locationPoints', request)
}

async function put(id, request) {
    return await putMethod(`/api/locationPoints/${id}`, request)
}

export {get, post, put}
